import { Stack, useTheme } from '@mui/material';
import React from 'react';
import { useDisclosure } from '@shared/hooks';

interface Props {
  children: (props: { isOpen: boolean; onToggle: () => void }) => React.ReactNode | React.ReactNode[];
}

export const MetadataBox: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  const { isOpen, onToggle } = useDisclosure(true);

  return (
    <Stack
      sx={{
        transition: 'all 0.2s ease-in-out',
        borderRadius: Number(theme.shape.borderRadius) / 2,
        border: `2px solid ${theme.vars.palette.divider}`,
        display: 'flex',
        gap: theme.spacing(isOpen ? 1 : 0),
        '& > *': {
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        },
        paddingBottom: theme.spacing(isOpen ? 2 : 0),
      }}
    >
      {children({ isOpen, onToggle })}
    </Stack>
  );
};
